module.exports = __webpack_public_path__ + "img/flower-white.019f1e26.png";